import { Store, StoreHelper, UserService } from '../services';
import { IUserInfo } from './user';
import { TopLevelComponent } from './top-level.component';

export class ProtectedTopLevelComponent extends TopLevelComponent {
    user: IUserInfo;

    constructor(public store: Store, public storeHelper: StoreHelper, userService: UserService) {
        super(store, storeHelper, userService);

        userService.user$.subscribe(user => {
            this.user = user;
            this.initialize();
        });

    }

    /*
     * This method will be called everytime there is a user change
     */
    initialize() {
        throw 'this method needs to be implement onthe derived class';
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/models/protected-top-level.component.ts